import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const loadZendeskWidget = (callback) => {
  const existingScript = document.getElementById('ze-snippet');

  if (!existingScript) {
    const script = document.createElement('script');
    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=f29fd6b1-3fbd-4b83-8a9f-4d3b5b19ba9c'; // URL for the third-party library being loaded.
    script.id = 'ze-snippet'; // e.g., googleMaps or stripe
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

export const ThirdPartyScripts = ({ page }) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && page?.type === 'Product') {
      setTimeout(() => {
        loadZendeskWidget(() => {
          window.zESettings = {
            chat: {
              concierge: {
                avatarPath:
                  'https://theme.zdassets.com/theme_assets/853722/5aea0806b47d86fa1a0485481023c2d07d4c5c8f.jpg',
                name: 'Alessandra',
                title: { '*': 'Live support' },
              },
            },

            webWidget: {
              color: {
                theme: '#000000',
                launcher: '#000000', // This will also update the badge
                launcherText: '#FFFFFF',
                button: '#1949E7',
                resultLists: '#691840',
                header: '#000000',
                articleLinks: '#691840',
              },
            },
          };
          if (window.zE) {
            window.zE('webWidget', 'helpCenter:setSuggestions', {
              labels: ['where-is-my-order', 'return', 'modify-order'],
            });
          }
        });
      }, 10000);
    }
  }, []);

  return (
    <Helmet>
      <script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        async
      />
    </Helmet>
  );
};
